import classnames from 'classnames';
import Image from "@/app/[lang]/components/shared/SmartImage";
import { FiX } from 'react-icons/fi';

import style from '../style.module.scss';
import StationMetaRows from './StationMetaRows';
import StationPricingCards from './StationPricingCards';

interface StationModalProps {
    station: any;
    stationIconSrc: string;
    googleMapsUrl: string | null;
    statusLabel: string;
    statusClassName: string;
    distanceLabel: string;
    distanceReferenceLabel: string;
    onClose: () => void;
    getConnectorIcon: (connectorType: string) => { src: string } | null;
}

const StationModal = ({
    station,
    stationIconSrc,
    googleMapsUrl,
    statusLabel,
    statusClassName,
    distanceLabel,
    distanceReferenceLabel,
    onClose,
    getConnectorIcon,
}: StationModalProps) => {
    const data = station.properties?.data;

    if (!data) return null;

    const stationId = station.properties?.id ?? data.id;

    return (
        <>
            <button
                className={style.stationModalBackdrop}
                type="button"
                aria-label="Închide detaliile stației"
                onClick={onClose}
            />
            <aside className={style.stationModal}>
                <div className={classnames(style.stationCard, style.stationCardModal, style.stationCardActive)}>
                    <div className={style.stationHeader}>
                        <span className={style.stationIcon}>
                            <Image src={stationIconSrc} alt="Station icon" width={28} height={28} />
                        </span>
                        <div className={style.stationTitle}>{data.name ?? `Stație ${stationId}`}</div>
                        <button
                            type="button"
                            className={style.stationCloseIcon}
                            aria-label="Închide detaliile stației"
                            onClick={onClose}
                        >
                            <FiX />
                        </button>
                    </div>
                    <div className={style.stationModalBody}>
                        {data.location && <div className={style.stationAddress}>{data.location}</div>}

                        <StationMetaRows
                            openingHours={data.openingHours}
                            stationType={data.type}
                            statusLabel={statusLabel}
                            statusClassName={statusClassName}
                            distanceReferenceLabel={distanceReferenceLabel}
                            distanceLabel={distanceLabel}
                        />

                        <div className={style.stationExpanded}>
                            {Array.isArray(data.pricing) && (
                                <StationPricingCards
                                    pricing={data.pricing}
                                    stationId={stationId}
                                    pricingKeyPrefix="modal-pricing"
                                    promoLabel="1,50 RON/kWh"
                                    getConnectorIcon={getConnectorIcon}
                                />
                            )}
                        </div>
                    </div>

                    <div className={style.stationModalFooter}>
                        <a
                            href={googleMapsUrl ?? '#'}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={style.stationActionButton}
                            onClick={(event) => {
                                if (!googleMapsUrl) {
                                    event.preventDefault();
                                }
                            }}
                        >
                            Mergi la stația de încărcare
                        </a>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default StationModal;
